<template>
  <div
    class="iframe-content"
    v-loading="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-text="Loading"
  >
    <div class="refreshPath">{{refreshPath}}</div>
    <iframe
      v-for="item in iframeList"
      :key="item.path"
      :src="$http.defaults.baseURL+getPath(item.path)+'?wmode=opaque'"
      :class=" getPath(item.path) === path ?'show iframe':'hidden iframe'"
      v-show="getPath(item.path)===path"
      :name="getPath(item.path)"
      :id="getPath(item.path)"
      frameborder="0"
      width="100%"
      @load="send(getPath(item.path),$http.defaults.baseURL+getPath(item.path))"
    ></iframe>
  </div>
</template>
<script>
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    iframeList() {
      return this.$store.state.options.filter(item => {
        return item.path.includes("iframe");
      });
    },
    path() {
      let path = this.$route.query.path;
      if (path) return Base64.decode(unescape(this.$route.query.path));
      return this.$route.fullPath;
    },
    refreshPath() {
      let refreshPath = this.$store.state.refreshPath;
      if(!refreshPath) return;
      let refreshIframe = document.getElementById(this.getPath(refreshPath));
      refreshIframe.src = "";
      refreshIframe.src = this.$http.defaults.baseURL + this.getPath(refreshPath) + "?wmode=opaque";
      this.$store.commit("SET_REFRESH_PATH","");
      return refreshPath;
    }
  },
  mounted() {},
  methods: {
    getPath(path) {
      if (!path) return false;
      if (path.includes("iframe?path="))
        return Base64.decode(unescape(path.split("=")[1]));
      return path;
    },
    send(name, url) {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
      let state = this.$store.state;
      let data = {
        token: state.token,
        userInfo: {
          id: state.userInfo.userId,
          name: state.userInfo.userName,
          communityId: state.userInfo.communityId,
        }
      };
      let iframe = window.frames[name];
      if (!iframe) return;
      iframe.postMessage(data, url);
    }
  }
};
</script>
<style lang='less' scoped>
.iframe-content {
  height: 100%;
  iframe {
    // z-index:-999 !important;
  }
  .show {
    height: 100%;
    // z-index:-999 !important;
  }
  .hidden {
    height: 0;
  }
  .refreshPath{
    display: none;
  }
}
/deep/ .el-icon-loading {
  font-size: 35px;
}
</style>